<template>
  <div id="consignor">
    <v-row>
      <v-col
        v-if="$vuetify.breakpoint.mdAndUp"
        md="5"
      >
      <v-img :src="adminConsignor.imageUrl"></v-img>
      </v-col>
      <v-col md="7">
        <v-card flat tile>
          <v-card-title class="text-h4">{{ adminConsignor.name }}</v-card-title>
          <v-card-text v-html="adminConsignor.description"></v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Current Investments -->
    <v-card flat tile>
      <v-card-title>Current</v-card-title>
      <v-card-text>
        <v-row v-if="flipAssetList.entries">
          <v-col
              v-for="(asset, a) in flipAssetList.entries"
              :key="a"
              cols="12"
              md="3"
              sm="6"
              class="align-self-stretch"
              >
              <CarCard :asset="asset"></CarCard>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Past Investments -->
    <ConsigPastInvestments></ConsigPastInvestments>
  </div>
</template>

<script>
  import CarCard from '../components/CarCard.vue'
  import ConsigPastInvestments from '../components/ConsigPastInvestments.vue'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'Consignor',

    components: {
      CarCard,
      ConsigPastInvestments
    },

    computed: {
      ...mapGetters([
        'flipAssetList',
        'adminConsignor',
        'consignorInvestments'
      ]),
    },

    methods: {
      ...mapActions([
        'getConsignorById',
        'getConsignorAssetInfo',
        'getFlipAssets'
      ]),
    },

    async created() {
      // Grab the asset and owner.
      await this.getConsignorById(this.$route.params.id)
      await this.getConsignorAssetInfo(this.$route.params.id)
      await this.getFlipAssets({
        sort: null,
        consignorId: this.$route.params.id
      })
    }
  }
</script>
